export default "__VITE_ASSET__64ebd503__"